//REGISTER
export const POST_FAKE_REGISTER = '/post-fake-register';

//LOGIN
export const POST_FAKE_LOGIN = '/post-fake-login';
export const POST_FAKE_JWT_LOGIN = '/post-jwt-login';
export const POST_FAKE_PASSWORD_FORGET = '/fake-forget-pwd';
export const POST_FAKE_JWT_PASSWORD_FORGET = '/jwt-forget-pwd';
export const SOCIAL_LOGIN = '/social-login';

//PROFILE
export const POST_EDIT_JWT_PROFILE = '/post-jwt-profile';
export const POST_EDIT_PROFILE = '/post-fake-profile';

export function buildUrlWithParams(urlTemplate, params = {}) {
  let url = urlTemplate;

  Object.entries(params).forEach(([key, value]) => {
    // if (value !== undefined) {
    // url = url.replace(`:${key}`, encodeURIComponent(String(value)));
    // }
    url = url.replace(`:${key}`, encodeURIComponent(String(value)));
  });

  return url;
}

// utils/isValidParams.ts
export const isValidParams = (params = {}) => {
  return (
    Object.keys(params).length > 0 &&
    Object.values(params).every(
      (value) => value !== undefined && value !== null && value.trim() !== '',
    )
  );
};
